"use client";

import dynamic from "next/dynamic";

/**
 * Lazy client wrappers for the Master Blocks blocks.
 *
 * next/dynamic only code-splits when the dynamic() call itself lives inside a
 * client boundary. Calling it from the server BlockRenderer maps meant every
 * client block was pulled into each route's client bundle — a blog post shipped
 * InfoBox, Rating, Table, TestimonialSlider and the rest despite never
 * rendering them. Declaring them here gives each block its own chunk, fetched
 * only when a post actually contains that block.
 *
 * Server-component blocks stay in the map files: they must not be imported
 * across a client boundary.
 */

export const MbButtons = dynamic(() => import("@litonarefin/components/MbBlocks/Buttons"));
export const MbButton = dynamic(() => import("@litonarefin/components/MbBlocks/Button"));
export const TestimonialSlider = dynamic(() => import("@litonarefin/components/MbBlocks/TestimonialSlider"));
